<template>
    <div>
      <carousel>
        <slide>
          Slide 1 Content
        </slide>
        <slide>
          Slide 2 Content
        </slide>

      </carousel>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide
  },
    mounted() {

    },
    data () {
        return {

        }
    },
    methods: {

    },
    props: {
        elements: {
            type: Array,
            required: true
        },

    }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
